/* eslint-disable react/jsx-no-useless-fragment */
import { Heading, Container, useColorMode } from "@chakra-ui/react";

interface HelpHeaderProps {
  title: string;
}

const BLUE = "rgb(0, 33, 71)";

export default function BlogHeader({ title }: HelpHeaderProps) {
  const { colorMode } = useColorMode();

  return (
    <Container maxW="5xl" textAlign="left" py={{ base: 10, md: 14 }} px={14}>
      <Heading
        color={colorMode === "light" ? BLUE : "white"}
        fontWeight={600}
        fontSize={{ base: "2xl", sm: "4xl", md: "6xl" }}
        lineHeight="110%"
      >
        {title}
      </Heading>
    </Container>
  );
}
